import { Component, OnInit, Input } from '@angular/core';
import { Flow } from '../obj/Flow';

@Component({
    selector: 'app-flow-owners',
    templateUrl: './flow-owners.component.html',
    styleUrls: ['./flow-owners.component.css'],
    standalone: false
})
export class FlowOwnersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  @Input() flow: Flow;
  tags: string[];
  newTag: string = '';
  flowData: any;
  isSaving: boolean = false;

  owners: any[];

  addOwner() {

  }

  deleteOwner(tag){
    
  }
  
}
